import { Box, Typography, styled } from "@mui/material"

export const OpportunityDetailWrapper = styled(Box)({
    width: "260px",
    // height: "150px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "14px 20px",
    color: "#FFFFFF"
    // border: "1px solid red"
})

export const OpportunityDetailLoadingWrapper = styled(Box)({
    width: "145px",
    height: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // border: "1px solid red"
})
